<template>
  <v-card>
    <v-card-title class="headline pb-0 px-4" primary-title>
      Editar dayparting
    </v-card-title>

    <v-card-text class="px-4">
      <nx-dayparting-event-editor ref="editor" v-model="draft"></nx-dayparting-event-editor>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn dark flat color="error" @click="cancel">
        {{ $t('message.common.cancel') }}
      </v-btn>

      <v-btn color="secondary" flat @click="accept">
        {{ $t('message.common.accept') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import NxDaypartingEventEditor from '@/modules/board/dayparting/components/EventEditor';
import { SCHEDULE_TYPE_ONCE, SCHEDULE_TYPE_RECURRENT } from '@/modules/board/dayparting/config';
import { rruleParser } from '@/modules/board/dayparting/helpers';
import { padStart } from 'lodash';
import moment from 'moment';

export default {
  name: 'nx-dayparting-module-event-editor',
  components: {
    NxDaypartingEventEditor,
  },
  data() {
    return {
      uuid: null,
      event: {},
      draft: {
        scheduleType: SCHEDULE_TYPE_ONCE,
        startDate: null,
        startTime: null,
        endDate: null,
        endTime: null,
        days: [],
      },
    };
  },
  computed: {
    scheduleType() {
      if (this.event.rrule) {
        return SCHEDULE_TYPE_RECURRENT;
      }
      return SCHEDULE_TYPE_ONCE;
    },
    startDate() {
      return moment(this.event.dtstart).format('YYYY-MM-DD');
    },
    startTime() {
      return moment(this.event.dtstart).format('HH:mm');
    },
    endDate() {
      if (!this.event.dtend) {
        return null;
      }
      return moment(this.event.dtend).format('YYYY-MM-DD');
    },
    endTime() {
      if (!this.event.dtend) {
        return null;
      }
      return moment(this.event.dtend).format('HH:mm');
    },
    rrule() {
      if (!this.event.rrule) {
        return null;
      }

      return rruleParser(this.event.rrule);
    },
    days() {
      if (!this.rrule) {
        return [];
      }

      const rrule = rruleParser(this.event.rrule);
      const numberToDay = {
        1: 'MO',
        2: 'TU',
        3: 'WE',
        4: 'TH',
        5: 'FR',
        6: 'SA',
        0: 'SU',
      };

      if (!rrule.dayOfWeek) {
        return Object.values(numberToDay);
      }

      return rrule.dayOfWeek.map(day => numberToDay[day]);
    },
    periodStart() {
      if (!this.rrule) {
        return null;
      }
      if (!this.rrule.times || this.rrule.times.length === 0) {
        return null;
      }
      const duration = moment.duration(this.event.duration);
      if (duration >= moment.duration(24, 'hours')) {
        return null;
      }
      const hour = padStart(this.rrule.times[0].hour, 2, '0');
      const minutes = padStart(this.rrule.times[0].minute, 2, '0');
      return `${hour}:${minutes}`;
    },
    periodEnd() {
      if (!this.periodStart) {
        return null;
      }
      const duration = moment.duration(this.event.duration);
      const end = moment(this.periodStart, 'HH:mm').add(duration);
      return end.format('HH:mm');
    },
  },
  methods: {
    editEvent(event) {
      // Load event
      console.log('Edit event', event);
      this.uuid = event.uuid;
      this.event = event.event;
      this.draft = {
        scheduleType: this.scheduleType,
        startDate: this.startDate,
        startTime: this.startTime,
        endDate: this.endDate,
        endTime: this.endTime,
        days: this.days,
        periodStart: this.periodStart,
        periodEnd: this.periodEnd,
      };
    },
    close() {
      this.$emit('close');
      this.reset();
    },
    reset() {
      this.event = {};
    },
    cancel() {
      this.reset();
      this.close();
    },
    accept() {
      this.$emit('edit', {
        uuid: this.uuid,
        event: this.$refs.editor.event,
      });
      this.cancel();
    },
  },
};
</script>
